import { Typography } from 'antd';
import { AppModal, AppModalContent, AppModalFooter } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppCheckbox } from 'shared/UI/UIKit/Checkbox';
import { scheduleConstraintLabels } from 'features/schedule-configuration/model';
import { ScheduleConstraintCode, type ScheduleConstraint } from 'services/api';
import { AppSelect } from 'shared/UI/UIKit/Select';
import { useRefineModal } from '../model/use-refine-modal';
import styles from './styles.module.scss';

export type RefineModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  configurationId: string | undefined;
  timetableId: string | undefined;
  initialConstraints: ScheduleConstraint[];
};

export const RefineModal = ({
  open,
  onClose,
  onSuccess,
  configurationId,
  timetableId,
  initialConstraints,
}: RefineModalProps) => {
  const {
    state: {
      submitting,
      allChecked,
      indeterminate,
      checkedCount,
      constraints,
      difficultyDistributionModelCode,
    },
    methods: {
      handleCheckAll,
      handleConstraintChange,
      handleDifficultyDistributionModelChange,
      handleSubmit,
      handleClose,
      isConstraintChecked,
    },
  } = useRefineModal({
    open,
    onClose,
    onSuccess,
    configurationId,
    timetableId,
    initialConstraints,
  });

  const content = (
    <div className={styles.list}>
      <div className={styles.checkAllRow}>
        <AppCheckbox checked={allChecked} indeterminate={indeterminate} onChange={handleCheckAll}>
          Выбрать все
        </AppCheckbox>
      </div>
      <div className={styles.items}>
        {constraints.map((constraint) => (
          <div key={constraint.code} className={styles.item}>
            <AppCheckbox
              checked={isConstraintChecked(constraint.code)}
              onChange={(e) => handleConstraintChange(constraint.code, e.target.checked)}
            >
              {scheduleConstraintLabels[constraint.code]}
            </AppCheckbox>
            {constraint.code === ScheduleConstraintCode.DAILY_DIFFICULTY_DISTRIBUTION_CONFLICT &&
              constraint.mode === 'ENABLED' && (
                <AppSelect
                  options={[
                    { label: 'Горка', value: 'HILL' },
                    { label: 'Змейка', value: 'SNAKE' },
                  ]}
                  value={difficultyDistributionModelCode}
                  onChange={handleDifficultyDistributionModelChange}
                  style={{ width: '100px ' }}
                />
              )}
          </div>
        ))}
      </div>
      <Typography.Text className={styles.count}>
        Выбрано ограничений: {checkedCount}
      </Typography.Text>
    </div>
  );

  return (
    <AppModal
      visible={open}
      onCancel={handleClose}
      title="Достроить расписание"
      content={<AppModalContent>{content}</AppModalContent>}
      customFooter={
        <AppModalFooter direction="row" unit="8" justifyContent="flex-end">
          <AppFlex direction="row" unit="8" justifyContent="flex-end">
            <AppButton type="outline" onClick={handleClose}>
              Отмена
            </AppButton>
            <AppButton
              type="primary"
              onClick={handleSubmit}
              loading={submitting}
              disabled={!configurationId || !timetableId}
            >
              Достроить
            </AppButton>
          </AppFlex>
        </AppModalFooter>
      }
      destroyOnClose
      maskClosable={false}
    />
  );
};
